define(['jQuery',
        'library/fcse-compatibility/object',
        'clientComponents/googletagmanager/GtmBase'],
    /**
     * @returns {GtmCommonPage}
     */
    function ($, Object, GtmBase) {

        function GtmCommonPage(options) {
            GtmBase.apply(this, arguments);
        }

        GtmCommonPage.prototype = $.extend(Object.create(GtmBase.prototype), /** @lends GtmCommonPage.prototype */{
            trackPage: function () {
                const self = this;
                try {
                    if (window.dataLayer) {
                        const result = $.grep(window.dataLayer, function(e) {
                            return (typeof e.pageType !== 'undefined' && e.pageType);
                        });
                        if (!result.length) {
                            const data = {
                                canonicalUrl: window.location.href,
                            };
                            const pageType = this.option('pageType');
                            if (pageType) {
                                data.pageType = pageType;
                            }
                            self.trackData(data);
                        }
                    }
                } catch (e) {}
            }
        });

        return GtmCommonPage;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/googletagmanager/GtmCommonPage.js